import styled from "@emotion/styled";
import { H1, IconReactionMustHug, Link, LoadingSpinner, Table } from "atoms";
import { Head } from "features/misc";
import { useGetMintStatusReport } from "features/search";
import { getEtherscanURL } from "features/reviewable";

const hugLink = (slug: string) => `/projects/${slug}`;

function MintStatusReport() {
  const { data, isLoading } = useGetMintStatusReport();

  return (
    <main>
      <Head title="Mint Status Report | QA" />

      <H1>Mint Status Report</H1>

      <Table>
        <thead>
          <tr>
            <th>Project</th>
            <th>Mint Status</th>
            <th>Mint Date</th>
            <th>Size</th>
            <th>Supply</th>
            <th>Owners</th>
          </tr>
        </thead>
        <tbody>
          {data?.data.map((row) => (
            <tr key={row.id}>
              <td>
                <strong>{row.name}</strong>
                <div>
                  <IconLinkHug
                    href={hugLink(row.id)}
                    rel="noreferrer"
                    target="_blank"
                  >
                    <IconReactionMustHug />
                  </IconLinkHug>

                  {"contractAddress" in row && row?.contractAddress && (
                    <IconLink href={getEtherscanURL(row)} />
                  )}
                  {row?.links?.map((link) => (
                    <IconLink href={link.url} />
                  ))}
                </div>
              </td>
              <td>{"mintStatus" in row && row.mintStatus?.join(", ")}</td>
              <td>{"mintDate" in row && row.mintDate}</td>
              <td>
                {("collectionSize" in row && row.collectionSize) || "Unknown"}
              </td>
              <td>{("totalSupply" in row && row.totalSupply) || "N/A"}</td>
              <td>{("numOwners" in row && row.numOwners) || "N/A"}</td>
            </tr>
          ))}
        </tbody>
      </Table>

      {isLoading && <LoadingSpinner />}
    </main>
  );
}

const IconLinkHug = styled(Link)({
  verticalAlign: "middle",
  marginRight: "0.5rem",
  svg: { width: "23px" },
});

const IconLink = styled(Link)({
  verticalAlign: "middle",
  marginRight: "0.5rem",
});

export { MintStatusReport };
